module.exports = __webpack_public_path__ + "img/search.018985f3.jpeg";